import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';

export default function NewCase() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ patient_name: '', patient_dob: '', patient_gender: 'male', patch_serial: '', attach_date: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post('/cases', form);
      navigate('/cases');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create case');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <button style={styles.back} onClick={() => navigate('/cases')}>← Back to Cases</button>
      <h2 style={styles.title}>New Patient Case</h2>
      <div style={styles.card}>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          {[
            { label: 'Patient Name', name: 'patient_name', type: 'text', placeholder: 'Full name' },
            { label: 'Date of Birth', name: 'patient_dob', type: 'date' },
            { label: 'Patch Serial Number', name: 'patch_serial', type: 'text', placeholder: 'e.g. HP-2024-00123' },
            { label: 'Attach Date & Time', name: 'attach_date', type: 'datetime-local' },
          ].map(f => (
            <div key={f.name} style={styles.field}>
              <label style={styles.label}>{f.label}</label>
              <input style={styles.input} type={f.type} name={f.name} placeholder={f.placeholder || ''} value={form[f.name]} onChange={handleChange} required />
            </div>
          ))}
          <div style={styles.field}>
            <label style={styles.label}>Gender</label>
            <select style={styles.input} name="patient_gender" value={form.patient_gender} onChange={handleChange}>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Creating...' : 'Create Case'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: { maxWidth: '600px', margin: '0 auto', padding: '32px 24px' },
  back: { background: 'none', border: 'none', color: '#4f46e5', cursor: 'pointer', fontSize: '13px', marginBottom: '12px', padding: 0 },
  title: { fontSize: '20px', fontWeight: '600', color: '#1a1a2e', marginBottom: '24px' },
  card: { background: '#fff', padding: '32px', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' },
  field: { marginBottom: '18px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px', color: '#444' },
  input: { width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none' },
  button: { width: '100%', padding: '12px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', marginTop: '8px' },
  error: { background: '#fff0f0', color: '#e53e3e', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '13px' },
};